/**
 * en-GB messages added by Phase 2 task W9 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w9EnGB = {
    'p2w.rte.toolbar': 'Text formatting',
    'p2w.rte.bold': 'Bold',
    'p2w.rte.italic': 'Italic',
    'p2w.rte.underline': 'Underline',
    'p2w.rte.link': 'Link',
    'p2w.rte.bullets': 'Bulleted list',
    'p2w.rte.numbers': 'Numbered list',
    'p2w.rte.heading': 'Heading',
    'p2w.rte.quote': 'Quote',
    'p2w.rte.mergeField': 'Insert a field',
    'p2w.rte.mergeFieldPlaceholder': 'Insert a field…',
    'p2w.rte.linkText': 'link text',
    'p2w.rte.linkUrl': 'https://',
    'p2w.rte.help': 'Leave a blank line between paragraphs. Use **bold**, *italic*, ++underline++, [text](https://link), "- " for bullets, "1. " for numbers.',
    'p2w.email.subject': 'Subject',
    'p2w.email.body': 'Message',
    'p2w.email.replyTo': 'Reply-to address',
    'p2w.email.replyToHint': 'Replies go here. Leave empty to use the default sender.',
    'p2w.email.attachment': 'Attachment',
    'p2w.email.attachmentHint': 'One file, up to {max} MB (PDF, PNG, JPEG, DOCX or XLSX).',
    'p2w.email.attachmentChoose': 'Choose a file',
    'p2w.email.attachmentRemove': 'Remove {name}',
    'p2w.email.attachmentTooBig': '{name} is {size} MB. The limit is {max} MB.',
    'p2w.email.attachmentType': '{name} is not a PDF, PNG, JPEG, DOCX or XLSX file.',
    'p2w.email.qr': 'Include a QR code',
    'p2w.email.calendar': 'Attach a calendar invitation',
    'p2w.email.preview': 'Preview',
    'p2w.email.previewHint': 'Shown with sample values. Real emails use the real details.',
    'p2w.email.previewSubject': 'Subject: {subject}',
    'p2w.email.previewEmpty': 'Nothing to preview yet.',
    'p2w.email.previewQr': 'A QR code is attached.',
    'p2w.email.previewCalendar': 'A calendar invitation is attached.',
    'p2w.email.subjectRequired': 'Enter a subject.',
    'p2w.email.reset': 'Reset to default',
    'p2w.time.invalid': 'Enter a time such as 09:30.',
    'p2w.list.add': 'Add',
    'p2w.list.remove': 'Remove {value}',
    'p2w.list.removed': '{value} removed',
    'p2w.list.added': '{value} added',
    'p2w.list.duplicate': '{value} is already in the list.',
    'p2w.list.emailInvalid': '{value} is not a valid email address.',
    'p2w.list.phoneInvalid': '{value} is not a valid phone number.',
    'p2w.list.emailHint': 'Press Enter or comma to add an address.',
    'p2w.list.phoneHint': 'Press Enter or comma to add a number.',
    'p2w.list.max': 'You can add up to {max}.',
    'p2w.list.empty': 'None added yet.',
    'p2w.range.from': 'From',
    'p2w.range.to': 'To',
    'p2w.range.invalid': 'The end date must not be before the start date.',
    'p2w.range.today': 'Today',
    'p2w.range.last7': 'Last 7 days',
    'p2w.range.last30': 'Last 30 days',
    'p2w.range.thisMonth': 'This month',
    'p2w.range.presets': 'Quick ranges',
    'p2w.secret.copy': 'Copy',
    'p2w.secret.copied': 'Copied to the clipboard.',
    'p2w.secret.copyFailed': 'Could not copy. Select the text and copy it yourself.',
    'p2w.secret.once': 'This is the only time it is shown. Store it somewhere safe now.',
    'p2w.secret.confirm': 'I have stored it safely',
    'p2w.secret.done': 'Done',
    'p2w.status.active': 'Active',
    'p2w.status.pending': 'Pending',
    'p2w.status.failed': 'Failed',
    'p2w.status.disabled': 'Disabled',
    'p2w.status.info': 'Information',
};
//# sourceMappingURL=w9.js.map